import React from 'react';

import ProfileIllustration from 'Assets/banner/privacy-illustration.png';
import PrivacyOptions from 'Assets/privacy-options.svg';
import { useTextContext } from 'Contexts/textContext';
import { Button, Icon, Paragraph } from 'DesignLibrary/atoms';
import { BannerCard } from 'DesignLibrary/molecules/BannerCard';
import RichText from 'Shared/RichText';
import Text from 'Shared/Text';
import { getMedicareCalloutUrl, getMedicareCopyField, trackMedicareProductSelect } from 'Utils/medicare';

import { Container } from './styled';
import { YOUR_PRIVACY_CHOICES_URL, PRIVACY_POLICY_URL, MedicareDestination } from '../../../../constants';
import { CUSTOMER_PATH } from '../../../../utils/urls';

interface PrivacyBannerProps {
  isFirstPageView: boolean;
}

interface MedicareBannerProps {
  isFirstPageView: boolean;
  medicareDestination: MedicareDestination;
}

export const PrivacyBanner = ({ isFirstPageView }: PrivacyBannerProps) => {
  const onOpen = () => {
    window.open(PRIVACY_POLICY_URL, '_blank')?.focus();
  };

  return (
    <Container isFirstPageView={isFirstPageView}>
      <BannerCard imgUrl={ProfileIllustration} background="--colors-blue-50">
        <Paragraph size="small">
          <Text field="eligibility_section.privacy_banner_card" />
        </Paragraph>
        <Button stretch size="small" onClick={onOpen}>
          <Text field="eligibility_section.privacy_title" />
        </Button>
        <Button className="link" size="xsmall" buttonType="standalone" url={YOUR_PRIVACY_CHOICES_URL} stretch>
          <>
            <img src={PrivacyOptions} alt="Your Privacy Options" width={30} height={20} />
            <Text field="eligibility_section.do_not_sell_my_info_text" />
          </>
        </Button>
      </BannerCard>
    </Container>
  );
};

export const MedicareBanner = ({ isFirstPageView, medicareDestination }: MedicareBannerProps) => {
  const { retrieveContentfulData } = useTextContext();
  const onOpen = () => {
    const url = getMedicareCalloutUrl(medicareDestination, CUSTOMER_PATH);
    trackMedicareProductSelect(medicareDestination, url);
    window.open(url, '_blank')?.focus();
  };

  return (
    <Container isFirstPageView={isFirstPageView}>
      <BannerCard background="--colors-blue-50">
        <div
          className="medicare-banner-heading"
          style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
        >
          <Icon color="--colors-blue-500" type="HandHeart" />
          <RichText
            inlineParagraphs
            field={getMedicareCopyField(
              medicareDestination,
              retrieveContentfulData,
              'profile_side_panel_header',
            )}
          />
        </div>
        <Paragraph size="small">
          <RichText
            inlineParagraphs
            field="profile_section_addtl.medicare_info_card.profile_side_panel_details"
          />
        </Paragraph>
        <Button iconRight="ArrowSquareOut" stretch size="small" onClick={onOpen}>
          <Text
            field={getMedicareCopyField(
              medicareDestination,
              retrieveContentfulData,
              'profile_side_panel_button_text',
            )}
          />
        </Button>
      </BannerCard>
    </Container>
  );
};
